import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="yamap"
export default class extends Controller {
  static targets = ["map"]
  static values = {
    lat: Number,
    lng: Number
  }

  inityamap() {
    window.ymaps.ready(() => {
      console.log("Yamap is ready")
      console.log([this.latValue, this.lngValue])

      this.map = new ymaps.Map(this.mapTarget, {
        center: [this.latValue, this.lngValue],
        zoom: 10
      })

      this.map.controls.remove('geolocationControl'); // геолокация
      this.map.controls.remove('searchControl'); // поиск
      this.map.controls.remove('trafficControl'); // трафик
      this.map.controls.remove('typeSelector'); // тип карты
      this.map.controls.remove('fullscreenControl'); // полноэкранный режим
      //this.map.controls.remove('zoomControl'); // зум
      //this.map.controls.remove('rulerControl'); // линейка
      this.map.geoObjects.add(new ymaps.Placemark([this.latValue, this.lngValue]))
      console.log("Yamap map created")
      console.log(this.map)

    })
  }

  connect() {
    console.log("Yamap controller connected")
    if(window.ymaps) {
      this.inityamap()
    }
    else {
      console.log("Yamap waiting")

      const me = this;
      document.addEventListener('yamapload', function(){me.inityamap()})
    }
  }

  disconnect() {
    console.log('map cleanup');
    if(this.map)
    {
      this.map.destroy();
      this.map = null;
    }
  }
}
